import StatusColorful from "./StatusColorful";

export default function InputAdmin({
  label = "",
  isFile = false,
  isStatus = false,
  status = "",
  onClick,
}) {
  return (
    <div className="w-full flex flex-col gap-1.5">
      <span className="text-sm text-zi-text-light/50 dark:text-zi-text-dark/50">
        {label}
      </span>
      {isFile && (
        <a
          onClick={onClick}
          className="text-zi-text-light dark:text-zi-text-dark underline"
        >
          مشاهده
        </a>
      )}
      {isStatus && status === "done" ? (
        <StatusColorful
          SVGName="tick"
          text="تأیید شده"
          color="green"
          className="w-28"
        />
      ) : status === "stall" ? (
        <StatusColorful
          SVGName="stall"
          text="در انتظار تأیید"
          color="yellow"
          className="w-28"
        />
      ) : status === "failed" ? (
        <StatusColorful
          SVGName="failed"
          text="رد شده"
          color="red"
          className="w-28"
        />
      ) : status === "none" ? (
        <StatusColorful
          SVGName="star"
          text="انجام نشده"
          color="blue"
          className="w-28"
        />
      ) : (
        ""
      )}
    </div>
  );
}
